<template>
  <v-app class="us_user_profile">
    <v-app-bar color="blue-grey" src="/res/user_profile.jpg" dense dark app style="box-shadow:none;">
      <v-toolbar-title style="font-size:1rem;padding-left:1.2rem;">我的</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="goSetting" v-if="false">
        <v-icon>fa fa-cog</v-icon>
      </v-btn>
    </v-app-bar>
    <v-sheet>
        <v-content style="background:#f2f2f2;">
          <div style="padding-bottom:5.3rem;">
            <!-- 顶部 -->
            <div style="height:10rem;">
              <v-img class="white--text" src="/res/user_profile.jpg" style="width:100%;height:100%;" dark>
                <v-row style="width:90%;margin:auto;margin-top:1.15rem;color:#fff;">
                  <v-col :cols="3">
                    <v-avatar size="55">
                      <img :src="userInfo.headimgurl" alt="John">
                    </v-avatar>
                  </v-col>
                  <v-col :cols="9" style="padding:12px 0;">
                    <div style="font-size:1.08rem;font-weight:bold;color:rgba(255,255,255,0.95)">{{userInfo.nickname}}</div>
                    <!-- <div style="font-size:0.75rem;margin-top:0.3rem;">
                      <span style="background:rgba(255,255,255,0.3);padding:0.2rem 0.5rem;border-radius:2px;border:1px solid rgba(255,255,255,0.3);color:rgba(255,255,255,0.95)">
                        <i class="fa fa-university" aria-hidden="true" style="margin-right:0.25rem;"></i>
                        <span v-if="staffInfo.COMPANY_CODE">企业用户</span>
                        <span v-else>个人用户</span>
                      </span>
                    </div> -->
                  </v-col>
                </v-row>
              </v-img>
            </div>
            <!-- 个人信息 -->
            <div style="width:95%;margin:auto;margin-top:-3rem;">
              <v-card style="font-size:0.15rem;padding-bottom:0rem;border-radius:10px;" flat >
                <div class="us-item-title">个人信息</div>
                <v-list style="padding-bottom:0.5rem;padding-top:0.3rem;">
                  <v-list-item class="us_list_item" @click="goEdit('填写姓名', 'USER_NAME', name)">
                    <v-list-item-content style="padding:0.55rem 0;">
                      <v-list-item-title>
                        <v-row style="width:100%;margin:0;font-size:0.9rem;padding-top:0.056rem;">
                          <v-col :cols="6" style="padding:0;">姓名</v-col>
                          <v-col :cols="6" style="padding:0;text-align:right;color:#9e9e9e;">
                            <span v-if="name === ''">未填写</span>
                            <span v-else>{{name}}</span>
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon style="margin:0;margin-left:1rem;margin-top:0.69rem;">
                      <v-icon color="grey" style="margin-top:-0.2rem;">fa fa-angle-right</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                  <v-list-item class="us_list_item" @click="goBindTel(tel)">
                    <v-list-item-content style="padding:0.55rem 0;">
                      <v-list-item-title>
                        <v-row style="width:100%;margin:0;font-size:0.9rem;padding-top:0.056rem;">
                          <v-col :cols="6" style="padding:0;">手机号码</v-col>
                          <v-col :cols="6" style="padding:0;text-align:right;color:#9e9e9e;">
                            <span v-if="tel === ''">未绑定</span>
                            <span v-else>{{tel}}</span>
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon style="margin:0;margin-left:1rem;margin-top:0.65rem;">
                      <v-icon color="grey" style="margin-top:-0.2rem;">fa fa-angle-right</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                  <v-list-item class="us_list_item" @click="goHelpList">
                    <v-list-item-content style="padding:0.55rem 0;">
                      <v-list-item-title>
                        <v-row style="width:100%;margin:0;font-size:0.9rem;padding-top:0.056rem;">
                          <v-col :cols="6" style="padding:0;">帮助</v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon style="margin:0;margin-left:1rem;margin-top:0.65rem;">
                      <v-icon color="grey" style="margin-top:-0.2rem;">fa fa-angle-right</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list>
              </v-card>

              <v-card flat style="margin-top:0.5rem;border-radius:10px;padding-bottom:0.3rem;" v-if="false" >
                <div>
                  <span class="us-item-title">消息通知</span>
                  <span style="font-size:0.8rem;padding-top:0.3rem;float:right;color:#9e9e9e;padding-top:1.1rem;padding-right:1.25rem;" @click="goNotifyList">
                    <span style="font-size:0.8rem;">查看更多</span>
                    <i class="fa fa-angle-right" style="margin-left:0.3rem;" aria-hidden="true"></i>
                  </span>
                </div>
                <!-- <NotifyLastList style="margin-top:0.1rem;" v-if="!loading" /> -->
              </v-card>

              <CompanyList style="margin-top:0.5rem;" v-if="!loading" />

            </div>
            <!-- <div style="text-align:center;font-size:0.75rem;margin-top:2rem;color:#9e9e9e;">版本号: 1.2.3</div> -->
            <div style="text-align:center;font-size:0.75rem;margin-top:2rem;color:#9e9e9e;"><a style="color:#9e9e9e;" @click="goVer">版本号: 2.0</a></div>
          </div>

        </v-content>
    </v-sheet>
  </v-app>
</template>

<script>
import CompanyList from '../Company/CompanyListV2'
// import NotifyLastList from './components/NotifyLastList'
export default {
  components: {
    CompanyList
  },
  props: {},
  data() {
    return {
      userInfo: {},
      staffInfo: {},
      name: '',
      tel: '',
      loading: true,
      transition: 'fade-transition',
      bindTelState: false
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    that.init()
  },
  created() {
    // this.init();
  },
  activated() {
    var that = this
    // 刷新页面
    if (that.$router.refresh) {
      location.reload()
      return
    }
    // 如果不是返回来的全部刷新
    if (!that.$router.isBack) {
      that.init()
    } else {
      that.getProfile()
    }
  },
  methods: {
    // 获取我的信息
    async getProfile() {
      var that = this
      var res = await that.$api.bz.getUserProfile()
      // console.log('getUserProfile.res', res);
      if (!res.success) {
        console.log('获取我的信息失败', res);
        return
      }
      var data = res.data
      that.name = data.name;
      that.tel = data.tel;
      that.bindTelState = data.bind_tel_sid === 2;
      that.loading = false
    },
    // 修改我的信息
    goEdit(title, field, val) {
      var query = {
        title: title,
        field: field,
        val: val
      }
      this.$router.goPage({ path: '/TextInputPage', query: query })
    },
    init() {
      window.scroll(0, 0);
      var that = this
      that.loading = true
      that.$store.commit('SET_FNAVVAL', 3)
      that.staffInfo = that.$AppHelper.getCustomData('staff_info');
      that.userInfo = that.$AppHelper.getUserInfo()
      that.getProfile()
    },
    goNotifyList() {
      this.$router.goPage('/NotifyList')
    },
    goSetting() {
      this.$router.goPage('/UserSetting')
    },
    goBindTel() {
      var that = this
      // 如果已经绑定手机号码
      if (that.bindTelState) {
        that.$router.goPage('/BindTelInfo')
      } else {
        that.$router.goPage('/BindTel')
      }
    },
    goHelpList() {
      this.$router.goPage('/HelpList')
    },
    // 修改版本
    goVer() {
      this.$router.goPage({ path: '/ChangeVersion' })
    }
  }
}
</script>

<style scoped>
.us-item-title{
  padding-left:0.85rem;
  font-weight:bold;
  font-size:1.05rem;
  color:rgba(33,33,33,0.9);
  padding-top:0.8rem;
  display: inline-block;
}
.us_list_item{
  min-height:2.6rem;
  max-height:3rem;
  padding-right:0.15rem;
  padding-left:1.5rem;
}
</style>
